var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { style: { "margin-bottom": _vm.displayNewDashboard ? "0px" : "30px" } },
    [
      _c("navigation", { ref: "nav", on: { logout: this.logout } }),
      _c("window-resize"),
      _c("transition", { attrs: { name: "slide" } }, [
        _vm.isNavOpened
          ? _c(
              "div",
              [
                _c("sidebar", {
                  ref: "sidebar",
                  attrs: {
                    "menu-item-id": this.menuItemId,
                    "user-site-map": _vm.userMenu
                  },
                  on: {
                    "update:userSiteMap": function($event) {
                      _vm.userMenu = $event
                    },
                    "update:user-site-map": function($event) {
                      _vm.userMenu = $event
                    }
                  }
                })
              ],
              1
            )
          : _vm._e()
      ]),
      _vm.isSearchOpened ? _c("div", { staticClass: "blured-body" }) : _vm._e(),
      _c(
        "main",
        {
          staticClass: "page-content mt-6",
          class: { "mobile-responsive": _vm.isMobile, open: _vm.isNavOpened },
          style: _vm.displayNewDashboard
            ? { "background-color": "#F1F6F4" }
            : {}
        },
        [
          _c("router-view"),
          _vm.canShowHelpFab
            ? _c("fab", { attrs: { draggable: true } })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }